import React, { useState, useEffect } from "react";
import { Marker, Popup, useMapEvents } from "react-leaflet";
import {
  getCurrentLocationIcon,
  getClickedLocationIcon,
} from "../mapComponents/MapIcon";
import MapPopup from "./MapPopup";

const MapHandler = () => {
  const [clickedLocation, setClickedLocation] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);

  const map = useMapEvents({
    click: (e) => setClickedLocation(e.latlng),
    locationfound: (e) => {
      setCurrentLocation(e.latlng);
      if (!map.hasCurrentLocation) {
        map.setView(e.latlng, map.getZoom());
        map.hasCurrentLocation = true;
      }
    },
  });

  useEffect(() => {
    map.locate();
  }, [map]);

  return (
    <>
      {currentLocation && (
        <Marker position={currentLocation} icon={getCurrentLocationIcon()}>
          <Popup closeButton={false}>
            <MapPopup
              location={currentLocation}
              onClose={() => map.closePopup()}
              isCurrentLocation={true}
            />
          </Popup>
        </Marker>
      )}
      {clickedLocation && (
        <Marker position={clickedLocation} icon={getClickedLocationIcon()}>
          <Popup closeButton={false}>
            <MapPopup
              location={clickedLocation}
              onClose={() => map.closePopup()}
              isCurrentLocation={false}
            />
          </Popup>
        </Marker>
      )}
    </>
  );
};

export default MapHandler;
